import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import type { IPageInfo } from '@/stores/pageCacheStore';
import { Icon } from '@/components';
import { useTabNavigate } from '@/hooks/useTabNavigate';

import './index.less';

interface PageTabProps {
  item: IPageInfo;
  iconRender?: () => React.ReactNode;
  onDelete?: () => void;
}
function PageTab({ item, iconRender, onDelete }: PageTabProps) {
  const { pathname, search } = window.location;
  const navigate = useTabNavigate();

  const active = item.key === `${pathname}${item.singleTab ? '' : search}`;

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    // 对工作台首页使用带强制刷新的跳转逻辑
    if (item.key === '/module/workbench/dashboard') {
      e.preventDefault();
      navigate(item.key);
    }
  };

  return (
    <div
      className={classNames('page-tab', {
        active,
      })}
      key={item.key}
    >
      <Link className="page-tab-link" to={item.key} onClick={handleClick}>
        {iconRender ? iconRender() : null}
        {item.name}
      </Link>
      {onDelete ? (
        <Icon className="page-tab-close" type="icon-biaoqianyeguanbi" onClick={onDelete} />
      ) : null}
    </div>
  );
}

export default PageTab;
